import notpermission from './notpermission'

const install = function(Vue) {
  Vue.directive('notpermission', notpermission)
}

if (window.Vue) {
  window['notpermission'] = notpermission
  Vue.use(install); // eslint-disable-line
}

notpermission.install = install
export default notpermission